import QrScanModal, { QrScanModalBasePropsType } from './QrScanModal';

export type QrScanModalBaseProps = QrScanModalBasePropsType;

export default QrScanModal;
